// extracted by mini-css-extract-plugin
export default {"transparent":"TicketExchangeConfirmationPayment_transparent__0TVPe","divisor":"TicketExchangeConfirmationPayment_divisor__DVpor"};